import type { SVGProps } from "react";

export default function ChevronDownIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M16.0099 7.50049L10.1766 12.5005L4.34326 7.50049"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
